export default __webpack_public_path__ + "static/media/val7.f0b78417.png";